import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { DataUtils } from "../../common/views/DataUtils";
import { MenuModel, ProductMenuFilterOption, MenuFilterModel, MenuFilterType } from "../models/CategoryModel";
import { ProductCountByModel } from "../models/ProductModel";
import { ProductAccessoryService } from "../services/ProductAccessoryService";

export function useCategoryMenuVM() {
    const service = new ProductAccessoryService();

    const [originalList, setOriginalList] = useState<MenuModel[]>([]);
    const [list, setList] = useState<MenuModel[]>([]);

    /////////////////////////////////// Get List onLoad only one time ////////////////////////////////
    const getList = (model: ProductMenuFilterOption) => {
        const request = service.getMenu(model);
        DataUtils.onRequest(request, onResult);
    }

    const onResult = (result: IDataResult) => {
        if (result.status === ResponseStatus.success) {
            var menu = result.data as MenuModel[];

            for (var i = 0; i < menu.length; i++) {
                menu[i].index = i;
                menu[i].index2 = i;
                menu[i].isVisibled = menu[i].level <= 1;
                menu[i].lastChild = getLastChild(i, menu);

                let item = menu[i];

                if (item.isCollapsed && item.lastChild > -1) {
                    for (var j = i + 1; j <= item.lastChild; j++) {
                        menu[j].isVisibled = false;
                    }
                }
            }

            setOriginalList(menu);
        }
    }

    const getLastChild = (index: number, list: MenuModel[]) => {
        let item = list[index];
        var lastChild = -1;

        for (var i = index + 1; i < list.length; i++) {
            if (list[i].level > item.level) {
                lastChild = i;
            } else {
                return lastChild;
            }
        }

        return lastChild;
    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////

    //////////////////////////////////// On Open and Close Filte Menu ////////////////////////////////////
    const open = (selectedList: MenuFilterModel[], count: ProductCountByModel) => {
        const list = originalList.map(item => ({ ...item }));

        setCounts(list, count);
        setChecks(list, selectedList);

        setList(list);
    }

    const close = () => {
        setList([]);
    }

    const setCounts = (list: MenuModel[], countDict: ProductCountByModel) => {
        for (var i = 0; i < list.length; i++) {
            //list[i].index = 0;
            list[i].count = 0;
        }

        for (var j = 0; j < list.length; j++) {
            var item1 = list[j];

            if (item1.type === MenuFilterType.brand) {
                const count = countDict.brands[item1.value];
                if (count) list[j].count = count;
            } else {
                const count = countDict.categories[item1.value];
                if (count) list[j].count = count;
            }
        }

        for (var k = 0; k < list.length; k++) {
            var item2 = list[k];

            if (item2.lastChild > -1 && (k + 1) <= item2.lastChild) {
                for (var l = (k + 1); l <= item2.lastChild; l++) {
                    list[k].count += list[l].count;
                }
            }
        }
    }

    const setChecks = (list: MenuModel[], selectedList: MenuFilterModel[]) => {
        for (let i = 0; i < selectedList.length; i++) {
            let selectedItem = selectedList[i];

            let currentIndex = list.findIndex(
                (item) =>
                    item.type === selectedItem.type &&
                    item.value === selectedItem.value
            );

            if (currentIndex > -1) {
                list[currentIndex].isSelected = true;

                const currentItem = list[currentIndex];

                if (currentItem.lastChild > -1) {
                    for (let c = currentItem.index2 + 1; c <= currentItem.lastChild; c++) {
                        list[c].isSelected = true;
                        list[c].isDisabled = true;
                    }
                }
            }
        }
    }

    const getSelectedList = () => {
        var selectedList: MenuModel[] = [];

        var i = 0;
        while (i < list.length) {
            let item = list[i];

            if (item.isSelected) {
                selectedList.push(item);

                if (item.lastChild > -1) {
                    i = item.lastChild;
                }
            }

            i++;
        }

        return selectedList;
    }

    /////////////////////////////////////////////////////////////////////////////////////////////////////

    ///////////////////////////////////// Actions during Filter /////////////////////////////////////////
    const setCheck = (currentItem: MenuModel, checked: boolean) => {
        setList(prev =>
            prev.map(item =>
                item.index === currentItem.index
                    ? { ...item, isSelected: checked }
                    : item
            )
        );

        if (currentItem.lastChild > -1) {
            setList(prev =>
                prev.map((item, index) => isChild(currentItem, index)
                    ? { ...item, isSelected: checked, isDisabled: checked }
                    : item
                )
            );
        }
    }

    const setCollapse = (currentItem: MenuModel, collapsed: boolean) => {
        setList(prev =>
            prev.map(item =>
                item.index === currentItem.index
                    ? { ...item, isCollapsed: collapsed }
                    : item
            )
        );

        if (currentItem.lastChild > -1) {
            if (collapsed) {
                setList(prev =>
                    prev.map((item, index) => isChild(currentItem, index)
                        ? { ...item, isVisibled: false, isCollapsed: true }
                        : item
                    )
                );
            } else {
                setList(prev =>
                    prev.map((item, index) => isChild(currentItem, index) && currentItem.level + 1 === item.level
                        ? { ...item, isVisibled: true, isCollapsed: true }
                        : item
                    )
                );
            }
        }
    }

    const isChild = (parent: MenuModel, index: number) => {
        return parent.index2 < index && index <= parent.lastChild
    }

    return {
        originalList,
        list,

        getList,
        open,
        close,
        setCounts,
        getSelectedList,
        setCheck,
        setCollapse
    }
}